module.exports = __webpack_public_path__ + "static/img/code-overview-bg.4fd5025a.png";